import { combineReducers } from 'redux';
import user from './user/user.js';
import nav from './nav/nav.js';
import machineStandStill from './machineStandStill/machineStandStill.js';
import workstation from './workstation/workstation.js';
import workstationState from './workstationState/workstationState.js';
import qualityCheck from './qualityChecks/qualityCheck.js';
import general from './general/general.js';
import machineParameter from './machineParameter/machineParameter.js';
import notification from './notification/notification.js';


const rootReducer = combineReducers({
  user,
  nav,
  workstation,
  machineStandStill,
  qualityCheck,
  general,
  machineParameter,
  notification,
  workstationState
});

// const rootReducer = (initialState, state,action) => {
  
//     state = initialState;
// }

export default rootReducer;